<template>
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
		<path
			d="M0 8C0 10.12 0.84 12.16 2.34667 13.6533C3.85333 15.16 5.88 16 8 16C10.12 16 12.16 15.16 13.6533 13.6533C15.16 12.1467 16 10.12 16 8C16 5.88 15.16 3.84 13.6533 2.34667C12.1467 0.84 10.12 0 8 0C5.88 0 3.84 0.84 2.34667 2.34667C0.84 3.85333 0 5.88 0 8Z"
			fill="#2468C1"
		/>
		<path
			d="M4.33358 8.40574C3.88881 8.33239 3.88881 7.68444 4.33358 7.59886C5.93238 7.31768 7.20661 6.07069 7.55522 4.45694L7.57926 4.33469C7.67543 3.89457 8.30053 3.88235 8.3967 4.33469L8.43276 4.48139C8.79339 6.08292 10.0676 7.31768 11.6664 7.59886C12.1112 7.67222 12.1112 8.33239 11.6664 8.40574C10.0676 8.68692 8.79339 9.92169 8.43276 11.5232L8.3967 11.6699C8.30053 12.11 7.67543 12.11 7.57926 11.6699L7.55522 11.5477C7.20661 9.93391 5.93238 8.68692 4.33358 8.40574Z"
			stroke="white"
			stroke-width="1.5"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'BadgeSparkIcon',
});
</script>
